type Props = {
  labelTestId: string;
  valueTestId: string;
  label: JSX.Element;
  value?: string;
};

export const ProductInfoRow = ({ labelTestId, valueTestId, label, value }: Props) => {
  return (
    <div>
      <p data-testid={labelTestId} className="typo-secondary text-secondary-text">
        {label}
      </p>
      <p data-testid={valueTestId} title={value} className="typo-primary-400 truncate">
        {value || '-'}
      </p>
    </div>
  );
};
